import classNames from 'classnames';

import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';
import {
  Heading,
  type HeadingProps,
  Icon,
  type IconName,
  type IconSize,
  Stack,
} from '@iconik-io/uad';

import styles from './card_item_without_keyframes_thumbnail.module.css';

type CardSize = 's' | 'm';

const sizeToHeadingLevel: Record<CardSize, HeadingProps['level']> = {
  m: 3,
  s: 5,
};

// Card sizes and icon sizes are separate scales, so an m card gets the xl icon
const sizeToIconSize: Record<CardSize, IconSize> = {
  m: 'xl',
  s: 'm',
};

type CardItemWithoutKeyframesThumbnailProps = {
  objectType?: string;
  className?: string;
  mediaType?: string;
  iconName?: IconName;
  cardSize: CardSize;
};

export function CardItemWithoutKeyframesThumbnail({
  cardSize,
  className,
  mediaType,
  iconName = 'asset_type_unknown',
  objectType,
}: CardItemWithoutKeyframesThumbnailProps) {
  const classes = classNames(styles.not_available, className);

  if (objectType === OBJECT_TYPE_COLLECTIONS) {
    return (
      <Stack className={classes} alignItems="center" justifyContent="center">
        <Icon name="collection" size="xl" />
      </Stack>
    );
  }

  if (mediaType === 'Unknown') {
    return (
      <Stack className={classes} alignItems="center" justifyContent="center">
        <Icon name="asset_type_unknown" size={sizeToIconSize[cardSize]} />
      </Stack>
    );
  }

  if (!mediaType) {
    return (
      <Stack className={classes} alignItems="center" justifyContent="center">
        <Icon name={iconName} size={sizeToIconSize[cardSize]} />
      </Stack>
    );
  }

  return (
    <Stack className={classes} alignItems="center" justifyContent="center">
      <div className={styles.wrapper}>
        <Heading
          className={styles.heading}
          level={sizeToHeadingLevel[cardSize]}
        >
          {mediaType}
        </Heading>
      </div>
    </Stack>
  );
}
